import { ITableColumnHeader, ITableRow } from "../../../ui/building-blocks/DSSFramework";

export interface OperatorAdminRow extends ITableRow {
    honeywellId: string;
    firstName: string;
    lastName: string;
    userRole: string;
    lastLoggedIn: string;
    status: string;
    accessEndDate: string;
    accessStartDate: string;
    countryCode: string;
    emailId: string;
    phoneNumber: string;
    userId: number;
    userRoleId: number;
    userType: string;
  
}
export interface OperatorAdminStatusPayload {
  id: number;             
  status: string;
  storeFrontName: string;   
  customerId: number;       
}
export const columnHeader: ITableColumnHeader[] = [
    { id: 'contact', label: 'CONTACT' },
    { id: 'honeywellId', label: 'Uid' },
    { id: 'emailId', label: 'Honeywell ID' },
    { id: 'userRole', label: 'USER ROLE' },
    { id: 'lastLoggedIn', label: 'LAST LOGGED IN' },
    { id: 'actions', label: 'ACTIONS' },
];

export const INDS_CUSTOMER=18;
export const INDS_OP_ADMIN=21;
export const ActiveStatus='active';
export const InternalUserType='Internal';
export const ExternalUserType='External';
export const INDS_StoreFrontName="INDS"
export const Phone_Number='0000000000';
